export default [
  {
    word: 'Once',
    startMs: 0,
    endMs: 280,
  },
  {
    word: 'I',
    startMs: 280,
    endMs: 760,
  },
  {
    word: 'had',
    startMs: 760,
    endMs: 1120,
  },
  {
    word: 'a',
    startMs: 1120,
    endMs: 1280,
  },
  {
    word: 'yellow',
    startMs: 1280,
    endMs: 1560,
  },
  {
    word: 'duck,',
    startMs: 1560,
    endMs: 1880,
  },
  {
    word: 'I',
    startMs: 2760,
    endMs: 2840,
  },
  {
    word: 'gave',
    startMs: 2840,
    endMs: 3020,
  },
  {
    word: 'him',
    startMs: 3020,
    endMs: 3200,
  },
  {
    word: 'a',
    startMs: 3200,
    endMs: 3360,
  },
  {
    word: 'hat',
    startMs: 3360,
    endMs: 3540,
  },
  {
    word: 'and',
    startMs: 3540,
    endMs: 3860,
  },
  {
    word: 'named',
    startMs: 3860,
    endMs: 4059,
  },
  {
    word: 'him',
    startMs: 4059,
    endMs: 4400,
  },
  {
    word: 'Quackie.',
    startMs: 4400,
    endMs: 4900,
  },
  {
    word: 'Quackie',
    startMs: 5880,
    endMs: 6300,
  },
  {
    word: 'went',
    startMs: 6300,
    endMs: 6520,
  },
  {
    word: 'Quack',
    startMs: 6520,
    endMs: 6860,
  },
  {
    word: 'Quack',
    startMs: 6860,
    endMs: 7160,
  },
  {
    word: 'every',
    startMs: 7160,
    endMs: 7500,
  },
  {
    word: 'day.',
    startMs: 7500,
    endMs: 7820,
  },
  {
    word: 'We',
    startMs: 8700,
    endMs: 8800,
  },
  {
    word: 'splashed',
    startMs: 8800,
    endMs: 9180,
  },
  {
    word: 'in',
    startMs: 9180,
    endMs: 9360,
  },
  {
    word: 'puddles',
    startMs: 9360,
    endMs: 9780,
  },
  {
    word: 'and',
    startMs: 9780,
    endMs: 10000,
  },
  {
    word: 'sang',
    startMs: 10000,
    endMs: 10240,
  },
  {
    word: 'songs.',
    startMs: 10240,
    endMs: 10880,
  },
  {
    word: 'One',
    startMs: 12000,
    endMs: 12180,
  },
  {
    word: 'time',
    startMs: 12180,
    endMs: 12460,
  },
  {
    word: 'a',
    startMs: 12460,
    endMs: 12640,
  },
  {
    word: 'frog',
    startMs: 12640,
    endMs: 12840,
  },
  {
    word: 'jumped',
    startMs: 12840,
    endMs: 13200,
  },
  {
    word: 'on',
    startMs: 13200,
    endMs: 13380,
  },
  {
    word: "Quackie's",
    startMs: 13380,
    endMs: 13900,
  },
  {
    word: 'hat,',
    startMs: 13900,
    endMs: 14080,
  },
  {
    word: 'boeing.',
    startMs: 14720,
    endMs: 15040,
  },
  {
    word: 'Quackie',
    startMs: 16020,
    endMs: 16480,
  },
  {
    word: 'laughed',
    startMs: 16480,
    endMs: 16760,
  },
  {
    word: 'and',
    startMs: 16760,
    endMs: 17060,
  },
  {
    word: 'I',
    startMs: 17060,
    endMs: 17220,
  },
  {
    word: 'laughed',
    startMs: 17220,
    endMs: 17440,
  },
  {
    word: 'too.',
    startMs: 17440,
    endMs: 17860,
  },
  {
    word: 'We',
    startMs: 18800,
    endMs: 18920,
  },
  {
    word: 'sat',
    startMs: 18920,
    endMs: 19140,
  },
  {
    word: 'on',
    startMs: 19140,
    endMs: 19300,
  },
  {
    word: 'a',
    startMs: 19300,
    endMs: 19420,
  },
  {
    word: 'log',
    startMs: 19420,
    endMs: 19580,
  },
  {
    word: 'and',
    startMs: 19580,
    endMs: 19820,
  },
  {
    word: 'ate',
    startMs: 19820,
    endMs: 19980,
  },
  {
    word: 'cookies.',
    startMs: 19980,
    endMs: 20300,
  },
  {
    word: 'The',
    startMs: 21200,
    endMs: 21420,
  },
  {
    word: 'end.',
    startMs: 21420,
    endMs: 21760,
  },
];
